import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const footerLinks = [
    { label: '首页', path: '/' },
    { label: '关于我们', path: '/about' },
    { label: '隐私政策', path: '/privacy' },
  ];

  const hotCategories = categories.slice(0, 4);

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-20 max-w-[1440px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-8">黑料入口</h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md mb-6">
              黑料入口站点承接51吃瓜黑料入口一二三、黑料入口官网及黑料入口下载需求，每日更新黑料网在线观看、吃瓜黑料在线等热门内容，为你整理安全可用的最新访问方式。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">热门分类</h3>
            <div className="flex flex-col gap-3">
              {hotCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-foreground-300 text-sm hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">快速链接</h3>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-foreground-300 text-sm hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/40">
        <div className="mx-auto px-4 md:px-6 py-6 max-w-[1440px] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 黑料入口 版权所有
          </p>
          <div className="flex items-center gap-6">
            {footerLinks.slice(1).map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground-500 text-xs hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}